import {
    Loading
} from 'element-ui'
/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};


//百分比
// 保留两位
function percentage2(num) {
    var precent = new Number(num);
    return precent.toFixed(2) + '%'
}
// 不保留
function percentage(num) {
    var precent = new Number(num);
    return precent.toFixed(0) + '%'
}
//无文本信息时输出“--”，否则输出[text+suffix]

function writeDashWithNoText(text, suffix) {
    return isEmpty(text) ? " -- " : text + sanitize(suffix);
}
// 无数字信息时输出，就输出0。
function writeDashWithNoNumer0(number) {
    return (isEmpty(number) || isNaN(number)) ? 0 : number;
}

//算小数
function writeDashWithNoNumer2(number, digits, suffix) {
    return isEmpty(number) || isNaN(number) ?
        '--' :
        toThousands(number, digits) + sanitize(suffix);
}

//算小数
function writeDashWithNoNumer4(num, n) {
    let number = num / 100000;
    n = n ? parseInt(n) : 0;
    if (n <= 0) {
        return Math.round(number);
    }
    number = Math.round(number * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
    number = Number(number).toFixed(n); //补足位数
    return number;
}



function isEmpty(val) {
    return sanitize(val) == "" ? true : false;
}

function sanitize(parameter) {
    if (
        parameter == undefined ||
        parameter == null ||
        parameter == "" ||
        parameter == "undefined" ||
        parameter == "--"
    ) {
        return "";
    }
    if (typeof parameter == "number") {
        return parameter.toString();
    }
    parameter += "";
    return parameter.trim();
}

function toThousands(num, accu) {
    num = toDecimal2(num, accu);
    var str = num.toString();
    var isfu = "";
    if (str.indexOf("-") != -1) {
        isfu = "-";
        str = str.substr(1, str.length - 1);
    }
    var arr = str.split(".");
    var result = "",
        counter = 0;
    var number = arr[0];
    number = (number || 0).toString();
    for (var i = number.length - 1; i >= 0; i--) {
        counter++;
        result = number.charAt(i) + result;
        if (!(counter % 3) && i != 0) {
            result = "," + result;
        }
    }
    if (arr.length > 1) {
        return isfu + result + "." + arr[1];
    } else {
        return isfu + result;
    }
}

//强制保留num位小数，accu为空，则不作处理
function toDecimal2(x, num) {
    var f = parseFloat(x);
    if (isNaN(f)) {
        return false;
    }
    if (isEmpty(num)) {
        return x;
    }

    var accu = "1";
    for (var i = 0; i < num; i++) {
        accu += "0";
    }

    var f = Math.round(x * accu) / accu;
    var s = f.toString();
    var rs = s.indexOf(".");
    if (rs < 0) {
        rs = s.length;
        s += ".";
    }
    while (s.length <= rs + num) {
        s += "0";
    }
    return s;
}




//导出数据
function exportFile(fileUrl, fileName) {
    let a = document.createElement("a");
    let blob = new Blob([fileUrl]);
    let objectUrl = URL.createObjectURL(blob);
    a.setAttribute("href", objectUrl);
    a.setAttribute("download", fileName + '.xlsx');
    a.click();
    URL.revokeObjectURL(objectUrl); // 释放内存
}


/**
 * 导出 
 **/
// 导出word
function exportWord(fileUrl, fileName) {
    let a = document.createElement("a");
    let blob = new Blob([fileUrl]);
    let objectUrl = URL.createObjectURL(blob);
    a.setAttribute("href", objectUrl);
    a.setAttribute("download", fileName + '.doc');
    a.click();
    URL.revokeObjectURL(objectUrl); // 释放内存
}



// 导出当前时间
function currentTime(res) {
    const date = res;
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return year + "/" + month + "/" + day;
}
// 字符串转日期
function getDate(strDate) {
    var date = eval('new Date(' + strDate.replace(/\d+(?=-[^-]+$)/,
        function(a) {
            return parseInt(a, 10) - 1;
        }).match(/\d+/g) + ')');
    return date;
}

export {
    timestampToTime,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    percentage,
    percentage2,
    writeDashWithNoNumer2,
    writeDashWithNoNumer4,
    writeDashWithNoText,
    writeDashWithNoNumer0,
    exportFile,
    currentTime,
    getDate,
    exportWord
}


// WEBPACK FOOTER //
// ./src/utils/util.js